/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * Explicit partial result; its denominator excludes unassigned advertising.
 * @export
 * @interface AssignedMarketingResultData
 */
export interface AssignedMarketingResultData {
    /**
     * 
     * @type {AssignedMarketingResultDataGrossProfitBasisEnum}
     * @memberof AssignedMarketingResultData
     */
    grossProfitBasis?: AssignedMarketingResultDataGrossProfitBasisEnum;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AssignedMarketingResultData
     */
    grossProfit?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AssignedMarketingResultData
     */
    assignedMarketingSpend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AssignedMarketingResultData
     */
    profitAfterAssignedMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AssignedMarketingResultData
     */
    poas?: number | null;
}


/**
 * @export
 */
export const AssignedMarketingResultDataGrossProfitBasisEnum = {
    Full: 'full',
    KnownLines: 'known_lines'
} as const;
export type AssignedMarketingResultDataGrossProfitBasisEnum = typeof AssignedMarketingResultDataGrossProfitBasisEnum[keyof typeof AssignedMarketingResultDataGrossProfitBasisEnum];


/**
 * Check if a given object implements the AssignedMarketingResultData interface.
 */
export function instanceOfAssignedMarketingResultData(value: object): value is AssignedMarketingResultData {
    return true;
}

export function AssignedMarketingResultDataFromJSON(json: any): AssignedMarketingResultData {
    return AssignedMarketingResultDataFromJSONTyped(json, false);
}

export function AssignedMarketingResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedMarketingResultData {
    if (json == null) {
        return json;
    }
    return {
        
        'grossProfitBasis': json['grossProfitBasis'] == null ? undefined : json['grossProfitBasis'],
        'grossProfit': json['grossProfit'] == null ? undefined : MoneyOutputFromJSON(json['grossProfit']),
        'assignedMarketingSpend': json['assignedMarketingSpend'] == null ? undefined : MoneyOutputFromJSON(json['assignedMarketingSpend']),
        'profitAfterAssignedMarketing': json['profitAfterAssignedMarketing'] == null ? undefined : MoneyOutputFromJSON(json['profitAfterAssignedMarketing']),
        'poas': json['poas'] === undefined ? undefined : json['poas'] === null ? null : json['poas'],
    };
}

export function AssignedMarketingResultDataToJSON(json: any): AssignedMarketingResultData {
    return AssignedMarketingResultDataToJSONTyped(json, false);
}

export function AssignedMarketingResultDataToJSONTyped(value?: AssignedMarketingResultData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grossProfitBasis': value['grossProfitBasis'],
        'grossProfit': MoneyOutputToJSON(value['grossProfit']),
        'assignedMarketingSpend': MoneyOutputToJSON(value['assignedMarketingSpend']),
        'profitAfterAssignedMarketing': MoneyOutputToJSON(value['profitAfterAssignedMarketing']),
        'poas': value['poas'],
    };
}

